import React, { useEffect } from "react";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";

export const Feefo = ({ className, scriptOnly }) => {
    useEffect(() => {
      const scriptId = "feefo-script-srg-talent";

      const scriptContainer = document.getElementById(scriptId);
      if (scriptContainer) scriptContainer.remove();

      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "text/javascript";
      script.src = "https://api.feefo.com/api/javascript/srg-talent";
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.getElementById(scriptId)?.remove();
      };
    }, []);

    if (scriptOnly && scriptOnly === true) {
        return null;
    }

    return (
      <section className={`${styles.root} ${className} position-relative text-center`}>
        <Container>
          <div
            id="feefo-service-review-carousel-widgetId"
            className="feefo-review-carousel-widget-service"
          />
        </Container>
      </section>
    );
  };
  
export default Feefo;
